// Database types matching the D1 schema

export interface User {
    id: string
    google_id: string
    email: string
    name: string
    picture: string
    phone?: string
    s_coins: number
    loyalty_points: number
    role: 'customer' | 'admin'
    created_at: string
}

export interface Product {
    id: string
    name: string
    description?: string
    category: string
    mrp: number
    sm_price: number
    stock: number
    barcode?: string
    image_url?: string
    ai_model_image_url?: string
    created_at: string
}

export interface Order {
    id: string
    user_id: string
    status: 'pending' | 'paid' | 'ready' | 'completed' | 'cancelled'
    total: number
    s_coins_used: number
    s_coins_earned: number
    payment_method: 'upi'
    pickup_code: string
    created_at: string
    items?: OrderItem[]
}

export interface OrderItem {
    id: string
    order_id: string
    product_id: string
    product_name: string
    quantity: number
    price: number
    product?: Product
}

export interface SCoinTransaction {
    id: string
    user_id: string
    amount: number
    type: 'earn' | 'redeem' | 'purchase'
    order_id?: string
    description?: string
    created_at: string
}

// Cart types
export interface CartItem {
    product: Product
    quantity: number
}

// API Response types
export interface ApiResponse<T> {
    success: boolean
    data?: T
    error?: string
}

// Google Auth types
export interface GoogleUserInfo {
    sub: string
    email: string
    name: string
    picture: string
    email_verified: boolean
}

// Config
export const APP_CONFIG = {
    STORE_NAME: 'SM Fashion',
    STORE_LOCATION: 'Nalgonda',
    STORE_TAGLINE: "Premium Women's Apparel",
    UPI_ID: 'paytmqr19cy28b20b@paytm',
    SCOINS_EARN_RATE: 10, // S-Coins per ₹100 spent
    SCOINS_REDEEM_RATE: 10, // 100 S-Coins = ₹10 discount
    DISCOUNT_PERCENTAGE: 10, // Default SM Price discount from MRP
    GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
    API_URL: import.meta.env.VITE_API_URL || '/api',
    ADMIN_EMAILS: ['bindu.0200@gmail.com'],
}

// Categories
export const PRODUCT_CATEGORIES = [
    'Sarees',
    'Kurtis',
    'Lehengas',
    'Suits',
    'Dress Materials',
    'Western Wear',
    'Ethnic Wear',
    'Accessories',
    'Others'
] as const

export type ProductCategory = typeof PRODUCT_CATEGORIES[number]
